import { RouteRecordRaw } from 'vue-router';

export const libraryRoutes: RouteRecordRaw[] = [
  {
    path: '/library',
    name: 'CompanyLibrary',
    component: () => import('@/pages/library/CompanyLibraryPage.vue'),
    children: [
      {
        path: 'functions',
        name: 'CompanyFunctions',
        component: () => import('@/pages/library/CompanyFunctionsPage.vue'),
      },
      {
        path: 'documents',
        name: 'CompanyDocuments',
        component: () => import('@/pages/library/CompanyDocumentsPage.vue'),
      },
      {
        path: 'links-and-tools',
        name: 'CompanyLinksAndTools',
        component: () => import('@/pages/library/CompanyLinksAndToolsPage.vue'),
      },
      {
        path: 'tags-and-topics',
        name: 'CompanyTagsAndTopics',
        component: () => import('@/pages/library/CompanyTagsAndTopicsPage.vue'),
      },
      {
        path: 'history',
        name: 'LibraryHistory',
        component: () => import('@/pages/company/LibraryHistoryPage.vue'),
      },
      {
        path: 'activities',
        name: 'CompanyActivities',
        component: () => import('@/pages/library/CompanyActivitiesPage.vue'),
        children: [
          {
            path: ':activityId',
            name: 'CompanyActivityRoot',
            component: () => import('@/pages/library/CompanyActivityRoot.vue'),
            children: [
              {
                path: '',
                name: 'CompanyActivityDetails',
                component: () =>
                  import('@/pages/library/CompanyActivityDetailsPage.vue'),
              },
              {
                path: 'completion-criteria',
                name: 'CompanyCriteria',
                component: () =>
                  import('@/pages/library/CompanyCriteriaPage.vue'),
                children: [
                  {
                    path: ':completionCriterionId',
                    name: 'CompanyCriterion',
                    component: () =>
                      import('@/pages/library/CompanyCriterionPage.vue'),
                  },
                ],
              },
              {
                path: 'checklist-steps',
                name: 'CompanyActivityChecklistSteps',
                component: () =>
                  // prettier-ignore
                  import('@/pages/library/CompanyActivityChecklistStepsPage.vue'),
              },
              {
                path: 'documents',
                name: 'CompanyActivityDocuments',
                component: () =>
                  import('@/pages/library/CompanyActivityDocumentsPage.vue'),
              },
              {
                path: 'links-and-tools',
                name: 'CompanyActivityLinksAndTools',
                component: () =>
                  import(
                    '@/pages/library/CompanyActivityLinksAndToolsPage.vue'
                  ),
              },
              {
                path: 'approvers',
                name: 'CompanyActivityApprovers',
                component: () =>
                  import('@/pages/library/CompanyActivityApproversPage.vue'),
              },
              {
                path: 'watchers',
                name: 'CompanyActivityWatchers',
                component: () =>
                  import('@/pages/library/CompanyActivityWatchersPage.vue'),
              },
              {
                path: 'history',
                name: 'CompanyActivityHistory',
                component: () =>
                  import('@/pages/company/LibraryHistoryPage.vue'),
              },
            ],
          },
        ],
      },
    ],
  },
];
